import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { getShareHolderDetails } from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";
import AddShareHolderDetailsForm from "./form/Addshareholderdetailsfrom";

const ShareHolderDetails = () => {
    const { showLoader, hideLoader } = useContext(WarehouseContext);
    const location = useLocation();
    const holder = location.state;
    const [details, setDetails] = useState([]);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        if (holder?.id) fetchDetails(holder.id);
    }, [holder]);

    const fetchDetails = async (id) => {
        showLoader();
        try {
            const response = await getShareHolderDetails(id);
            const data = response.data?.data || response.data;
            if (Array.isArray(data)) setDetails(data);
            else toast.info("No details found.");
        } catch (error) {
            console.error("Error fetching details:", error);
            toast.error("Error fetching details");
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="text-uppercase mb-0">Share Holder Details</h6>
                    <button className="btn btn-primary btn-sm" onClick={() => setShowForm(true)}>
                        + Add Details
                    </button>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="mb-3">
                            <strong>Name:</strong> {holder?.name}<br />
                            <strong>Phone:</strong> {holder?.phone}<br />
                            <strong>Equity:</strong> {holder?.equity}%
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered table-sm" style={{ fontFamily: "poppins" }}>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>name</th>
                                        <th>equity</th>
                                        <th>capital</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {details.length > 0 ? (
                                        details.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.name}</td>
                                                <td>{item.equity}</td>
                                                <td>{item.capital}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center text-muted">
                                                No details found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {showForm && (
                    <AddShareHolderDetailsForm
                        shId={holder.id}
                        closeModal={() => setShowForm(false)}
                        refreshList={() => fetchDetails(holder.id)}
                    />
                )}
            </div>
        </div>
    );
};

export default ShareHolderDetails;